import React from 'react';
import { twMerge } from 'tailwind-merge';

export const ImageGallery = (props) => {
  let array = props.children
    .split(/((?=\[)[\S\s]*?(?=])])((?=\[)[\S\s]*?(?=])])/)
    .filter((val) => val);
  const obj = JSON.parse(array[0]);
  const caption = array[1] ? array[1].slice(1, -1) : '';
  const layout =
    props.layout === undefined ? `figure-extra-wide` : `figure-${props.layout}`;

  const imageGalleryStyle = twMerge(
    layout,
    'not-prose grid grid-cols-1 gap-12 md:grid-cols-2'
  );

  return (
    <div className="relative">
      <div className="figure-background absolute -left-[40%] hidden h-full w-28 xl:block"></div>
      <div className={imageGalleryStyle}>
        {obj.map((entry) => {
          return (
            <div className="">
              <figure className="object-cover">
                <img src={entry.image} alt={entry.alt} />
                {entry.caption && entry.caption !== undefined && (
                  <figcaption>{entry.caption}</figcaption>
                )}
              </figure>
            </div>
          );
        })}
        {caption && caption !== 'undefined' && (
          <figcaption className="col-span-full mt-[-2rem] mb-6 border-b-2 border-b-stone-200 pb-2 font-sans text-sm text-stone-600">
            {caption}
          </figcaption>
        )}
      </div>
    </div>
  );
};
